var map = {
	".": 28,
	"./": 28,
	"./ADPM/Desktop.png": 607,
	"./Aicamping/Desktop.png": 512,
	"./Aicamping/Mobile.png": 796,
	"./CaseChronology/Desktop.png": 526,
	"./Enreach/Desktop.png": 855,
	"./EventHut/Desktop.png": 955,
	"./EventHut/Mobile.png": 64,
	"./QuizWizard/Desktop.png": 582,
	"./QuizWizard/Mobile.png": 220,
	"./SnailBuzz/Desktop.png": 294,
	"./SnailBuzz/Mobile.png": 997,
	"./Syno/Desktop.png": 916,
	"./Syno/Mobile.png": 652,
	"./index": 28,
	"./index.tsx": 28,
	"./projects": 336,
	"./projects.json": 336,
	"./styles.module.scss": 34,
	"pages/HomePage/ProjectsBlock": 28,
	"pages/HomePage/ProjectsBlock/": 28,
	"pages/HomePage/ProjectsBlock/ADPM/Desktop.png": 607,
	"pages/HomePage/ProjectsBlock/Aicamping/Desktop.png": 512,
	"pages/HomePage/ProjectsBlock/Aicamping/Mobile.png": 796,
	"pages/HomePage/ProjectsBlock/CaseChronology/Desktop.png": 526,
	"pages/HomePage/ProjectsBlock/Enreach/Desktop.png": 855,
	"pages/HomePage/ProjectsBlock/EventHut/Desktop.png": 955,
	"pages/HomePage/ProjectsBlock/EventHut/Mobile.png": 64,
	"pages/HomePage/ProjectsBlock/QuizWizard/Desktop.png": 582,
	"pages/HomePage/ProjectsBlock/QuizWizard/Mobile.png": 220,
	"pages/HomePage/ProjectsBlock/SnailBuzz/Desktop.png": 294,
	"pages/HomePage/ProjectsBlock/SnailBuzz/Mobile.png": 997,
	"pages/HomePage/ProjectsBlock/Syno/Desktop.png": 916,
	"pages/HomePage/ProjectsBlock/Syno/Mobile.png": 652,
	"pages/HomePage/ProjectsBlock/index": 28,
	"pages/HomePage/ProjectsBlock/index.tsx": 28,
	"pages/HomePage/ProjectsBlock/projects": 336,
	"pages/HomePage/ProjectsBlock/projects.json": 336,
	"pages/HomePage/ProjectsBlock/styles.module.scss": 34
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 334;